export const hasValidLinkedRouterPage = (value: unknown) =>
  typeof value === 'string' && !value.includes('_')
